import React from 'react';
import { Modal, Box, Typography, Button, CircularProgress, Grid }  from '@mui/material';

export const EVENT_MODAL_SUCCESS = "EVENT_MODAL_SUCCESS"
export const EVENT_MODAL_ERROR = "EVENT_MODAL_ERROR"
export const EVENT_MODAL_LOAD = "EVENT_MODAL_LOAD"

const GenericModal = ({ open, onClose, message, type }) => {
    const modalContent = () => {
        switch (type) {
            case 'EVENT_MODAL_SUCCESS':
                return {
                    title: "Success",
                    content: message,
                    actions: <Button variant="contained" color="primary" onClick={onClose}>OK</Button>
                };
            case 'EVENT_MODAL_ERROR':
                return {
                    title: "Error Occurred",
                    content: message,
                    actions: <Button variant="outlined" color="secondary" onClick={onClose}>Close</Button>
                };
            case 'EVENT_MODAL_LOAD':
                return {
                    title: message ?? "Processing",
                    content: <CircularProgress />,
                    actions: null  // No actions during loading
                };
            default:
                return {
                    title: "Info",
                    content: message,
                    actions: <Button variant="outlined" onClick={onClose}>Close</Button>
                };
        }
    };

    const { title, content, actions } = modalContent();

    return (
        <Modal
            open={open}
            onClose={onClose} // Disable closing on click away for loading
            aria-labelledby="custom-modal-title"
            aria-describedby="custom-modal-description"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Typography id="custom-modal-title" variant="h6" component="h2">
                    {title}
                </Typography>
                <Typography id="custom-modal-description" sx={{ mt: 2 }}>
                    {content}
                </Typography>
                {actions && (
                    <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                        <Grid item>{actions}</Grid>
                    </Grid>
                )}
            </Box>
        </Modal>
    );
};

export default GenericModal;
